module Environments {
    module.controller("AgentEditController", [
        "$scope",
        "AgentsService",
        function ($scope: IAgentScope, agentsService: IAgentService) {
            let agentGroup = $scope.agentGroup as IAgentGroup;
            var agent = _.find(agentGroup.executionAgents.concat(agentGroup.gatewayAgents), function (agent: IAgent) {
                return agent.name === $scope.$stateParams.agentName;
            });

            if (agent) {
                $scope.agent = {};
                agentsService.get(agent).then(function (response) {
                    if (response) {
                        $scope.agent = response.data;
                    }
                });
            } else {
                var environment = $scope.environment.name || "Default";
                $scope.$state.go("environments.detail", { environmentName: environment });
            }
        }
    ]);
}